module.exports = __webpack_public_path__ + "img/world-map.1cdd2dfc.png";